import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56aac3a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flex space-x-6 justify-center md:justify-end" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Filtruj ")

import { reactive, Component } from 'vue'
import { UiInput, UiSelect, UiDatePicker, UiButton } from '@/components/common/ui'
import { useHelpers } from '@/composables/useHelpers'
import { useFiltersStorage } from '@/composables/useFiltersStorage'
import { IFilterParam } from '@/types/interfaces/filters'

type Props = {
    columns?: boolean
    filtersSchema: IFilterParam[]
    cancelButtonText?: string
    useFilterStorage?: string
}
type Emits = {
    (e: 'submit', value: Record<string, unknown>): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    columns: { type: Boolean, required: false },
    filtersSchema: { type: Array, required: true },
    cancelButtonText: { type: String, required: false },
    useFilterStorage: { type: String, required: false }
  },
  emits: ["submit"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'submit', value: Record<string, unknown>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    columns?: boolean
    filtersSchema: IFilterParam[]
    cancelButtonText?: string
    useFilterStorage?: string
}




const FILTER_FORM_COMPONENT: Record<string, Component> = {
    input: UiInput,
    select: UiSelect,
    'date-range': UiDatePicker,
    date: UiDatePicker,
}

const initialFilterState = props.filtersSchema.reduce(
    (acc, _filter) => ({
        ...acc,
        [_filter.key]: undefined,
    }),
    {},
)

const { updateFilterStorage, clearFilterStorage, currentFilters } = useFiltersStorage(
    props.useFilterStorage,
)
const filters: Record<string, unknown> = reactive({
    ...initialFilterState,
    ...(props.useFilterStorage && {
        ...(currentFilters.value as Record<string, unknown>),
    }),
})

const { removeAllNullOrEmptyProperties } = useHelpers()
const submitFilter = () => {
    const _filters_ = removeAllNullOrEmptyProperties(filters)
    if (props.useFilterStorage) updateFilterStorage(_filters_)
    emit('submit', _filters_)
}

const clearForm = () => {
    Object.assign(filters, { ...initialFilterState })
    if (props.useFilterStorage) clearFilterStorage()
    emit('submit', {})
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      class: _normalizeClass([{ 'md:grid-cols-2': __props.columns }, "form grid grid-cols-1 max-h-[30rem] px-4 gap-0 md:gap-4 md:px-0 md:max-h-[100rem]"])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.filtersSchema, (filter, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `filer-${index}`
        }, [
          _createElementVNode("label", {
            id: `id-${filter.key}`,
            class: "font-basier font-semibold text-dark-gray text-sm"
          }, _toDisplayString(filter.label), 9, _hoisted_1),
          (_openBlock(), _createBlock(_resolveDynamicComponent(FILTER_FORM_COMPONENT[filter.type]), {
            modelValue: _unref(filters)[filter.key],
            "onUpdate:modelValue": ($event: any) => ((_unref(filters)[filter.key]) = $event),
            clearable: "",
            "aria-labelledby": `id-${filter.key}`,
            options: filter.options,
            "is-range": filter.type === 'date-range',
            "fix-on-popover": ""
          }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-labelledby", "options", "is-range"]))
        ]))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(UiButton), {
        outline: "",
        onClick: clearForm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.cancelButtonText || 'Wyczyść'), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(UiButton), {
        primary: "",
        onClick: submitFilter
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ]))
}
}

})